import { Activity, PropsWithChildren } from 'react';

import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import EmptyCastAndCrewBlur from './empty-cast-and-crew-blur';
import getProjectOverChannelColorCssVariable from '@/utils/colors/get-project-over-channel-color-css-variable';
import { EColorVariablesV2 } from '@/types/theme-packs.types';

type Props = PropsWithChildren<{
  title: string;
  description: string;
  loading?: boolean;
  height?: string;
}>;

const EmptyCastCrewShell = ({ height = '236px', loading, description, children, title }: Props) => {
  return (
    <Container
      data-component="EmptyCastCrewShell"
      height={height}
      className="flex-column ai-center jc-center gap-24 position-relative"
      border={loading ? '1px solid transparent' : '1px solid var(--global-stroke)'}
      borderRadius="16px"
      width="100%"
      skLoader={{ loading: !!loading, height, width: '100%' }}
    >
      <EmptyCastAndCrewBlur />
      <Activity mode={loading ? 'hidden' : 'visible'}>
        <Container className="flex-column ai-center gap-8">
          <Text tag="h3" className="H3" color={getProjectOverChannelColorCssVariable(EColorVariablesV2.primary, 'BG')}>
            {title}
          </Text>
          <Text className="S1" design="GlobalIcoText1">
            {description}
          </Text>
        </Container>

        <Container>{children}</Container>
      </Activity>
    </Container>
  );
};

export default EmptyCastCrewShell;
